import _ from 'lodash'
import Mustache from 'mustache'
import GlobalDataService from '@/services/GlobalDataService'

class TranslateService {
  constructor () {
    this.locales = ['en', 'tc', 'sc']
    this.currentLocale = 'en'
    this.dict = {}
    this.subscribeMap = {}
    this.history = {} // add by kong, for export translation
    this.missing = [] // add by kong, for export missing translation
  }

  async init () {
    const data = GlobalDataService.translations
    _.each(data, item => {
      _.set(this.dict, item.id, item.value)
    })
  }

  setCurrentLocale (locale, isUpdateUrl) {
    if (_.isEmpty(locale)) {
      return
    }
    this.currentLocale = locale

    _.each(this.subscribeMap.change, callback => {
      callback(this.currentLocale, isUpdateUrl)
    })
  }

  get (key, params, locale) {
    locale = locale || this.currentLocale
    const notCurrentLocale = this.locales.filter(x => x !== locale)[0]
    if (_.isString(key)) {
      if (_.isEmpty(key)) {
        return ''
      }
      key = _.toUpper(key)
      if (!_.startsWith(key, 'T_')) {
        console.warn(`key ${key} doesn't have T_ prefix`)
        key = `T_${key}`
      }
      if (this.dict[key] && this.dict[key][locale]) {
        const value = this.dict[key][locale]

        this.history[key] = this.dict[key] // add by kong, for export translation

        return Mustache.render(value, params)
      }
      if (!_.includes(this.missing, key)) {
        this.missing.push(key)
      }
      // console.error(`Did not find any translation for ${key}`)
      return key
    } else {
      const value = _.get(key, locale) || _.get(key, notCurrentLocale)
      if (!_.isString(value)) {
        return value
      }
      return Mustache.render(value, params)
    }
  }

  getAnyLocale (key, params) {
    let locale = this.currentLocale
    const locales = _.cloneDeep(this.locales)
    do {
      const trans = this.get(key, params, locale)
      if (typeof trans !== 'string') {
        _.remove(locales, row => {
          return row === locale
        })
        if (locales.length) locale = locales[0]
      } else {
        return trans
      }
    } while (locales.length)
    return key
  }

  getCurrentLocale () {
    return this.currentLocale
  }

  subscribe (event, callback) {
    if (!_.isString(event)) {
      throw new Error(`event (${event}) should be a string`)
    }
    if (!_.isFunction(callback)) {
      throw new Error('callback should be a function')
    }
    this.subscribeMap[event] = this.subscribeMap[event] || []
    this.subscribeMap[event].push(callback)
  }

  unsubscribe (event, callback) {
    if (!_.isString(event)) {
      throw new Error(`event (${event}) should be a string`)
    }
    if (!_.isFunction(callback)) {
      throw new Error('callback should be a function')
    }

    this.subscribeMap[event] = this.subscribeMap[event] || []
    this.subscribeMap[event] = _.difference(this.subscribeMap[event], [callback])
  }
}

export default new TranslateService()
